export const FETCH_WATCHLIST_REQUEST = "FETCH_WATCHLIST_REQUEST";
export const FETCH_WATCHLIST_SUCCESS = "FETCH_WATCHLIST_SUCCESS";
export const FETCH_WATCHLIST_ERROR = "FETCH_WATCHLIST_ERROR";

export const REMOVE_WATCHLIST_REQUEST = "REMOVE_WATCHLIST_REQUEST";
export const REMOVE_WATCHLIST_ERROR = "REMOVE_WATCHLIST_ERROR";
export const REMOVE_WATCHLIST_SUCCESS = "REMOVE_WATCHLIST_SUCCESS";

export const REMOVE_WATCHLIST_RESET_STATUS = "REMOVE_WATCHLIST_RESET_STATUS";

export const REMOVE_WATCHLIST_ACCESS_DENIED = "REMOVE_WATCHLIST_ACCESS_DENIED";
